import type { App, Plugin } from 'vue'
import { vSafeArea } from '../directives/safeArea'

export const SafeAreaPlugin: Plugin = {
  install(app: App) {
    app.directive('safe-area', vSafeArea)
  }
}

export * from '../directives/safeArea'
